import { useMutation } from '@tanstack/react-query';

import { postTermsOfUse } from 'apis/hcp/users.api';

const usePostTermsOfUse = (authType?: string) => {
  const { mutateAsync: saveTermsOfUse, isPending: saving } = useMutation({
    mutationFn: (values: { version_id: string; type: string }) => {
      return postTermsOfUse(values, authType);
    },
  });
  return { saveTermsOfUse, saving };
};

export default usePostTermsOfUse;
